import { GraphQLClient } from 'graphql-request'
import { DataProvider } from '@pankod/refine-core'
import { GetAuthenticationTypesDocument, GetAuthenticationTypeDocument } from '../../gql/graphql'

export const AuthenticationTypesDataProvider = (client: GraphQLClient): DataProvider =>
    ({
        getList: async ({ pagination, hasPagination }) => {
            const pageSize = pagination?.pageSize ?? 10
            const current = pagination?.current ?? 1
            const paging = hasPagination
                ? {
                      skip: (current - 1) * pageSize,
                      limit: pageSize,
                  }
                : {}
            const result = await client.request(GetAuthenticationTypesDocument, {
                skip: paging.skip,
                limit: paging.limit,
            })
            return {
                data: result.adminAuthenticationTypes.items,
                total: result.adminAuthenticationTypes.total,
            }
        },
        async getOne({ id }: { id: string }) {
            const result = await client.request(GetAuthenticationTypeDocument, { id })
            return { data: result.adminAuthenticationType }
        },
        // async update({ variables, id }: { variables: UpdateAuthenticationTypeInput; id: string }) {
        //     const { name, icon, parentId } = variables
        //     const sortIndex = variables.sortIndex ? Number(variables.sortIndex) : variables.sortIndex
        //     const updateAuthenticationTypeInput = {
        //         name: name,
        //         icon: icon,
        //         sortIndex: sortIndex,
        //         parentId: parentId,
        //     }

        //     const result = await client.request(UpdateAuthenticationTypeDocument, { id, updateAuthenticationTypeInput })
        //     return {
        //         data: result.adminAuthenticationTypeUpdate,
        //     }
        // },
    } as DataProvider)
